import React from 'react'

import { Card, RewardDestination, RewardHistoryStatus } from '@/components'
import {
  ERewardHistoryType,
  TRewardHistoryData,
} from '@/libs/apis/queries/use-get-list-reward-history-query'
import formatCurrency from '@/libs/helpers/format-currency'
import formatDate from '@/libs/helpers/format-date'
import formatDateTime from '@/libs/helpers/format-date-time'

export type TRewardHistorySection = {
  readonly date: string
  readonly histories: TRewardHistoryData[]
  readonly useOwnLoyaltyPlatform?: boolean
  readonly loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
}

export default function RewardHistorySection({
  date,
  histories,
  useOwnLoyaltyPlatform,
  loyaltyPlatform,
}: TRewardHistorySection) {
  const formatedDate = formatDate(new Date(date))

  const prefix = useOwnLoyaltyPlatform ? loyaltyPlatform?.loyaltyPlatformPrefix : 'Rp'
  const suffix = useOwnLoyaltyPlatform ? loyaltyPlatform?.loyaltyPlatformSuffix : ''

  return (
    <div className='flex flex-col gap-4'>
      <span className='text-xs font-semibold text-pop-grey-500'>{formatedDate}</span>
      <Card noElevation>
        {histories.map((history, index) => (
          <div key={history?.id} className='sentry-mask flex flex-col gap-4'>
            <section className='flex flex-row items-center justify-between gap-3'>
              <div className='flex flex-col gap-3'>
                <span className='mr-3 line-clamp-2 text-xs font-semibold'>
                  {history?.withdrawalType ||
                    (history?.type === ERewardHistoryType.CASH ? 'Income' : 'Withdrawal')}
                </span>
                <RewardDestination history={history} />
              </div>
              <div className='flex flex-col items-end gap-3'>
                {history?.type === ERewardHistoryType.CASH ? (
                  <span className='text-xs font-semibold text-pop-green-500'>
                    +{prefix}
                    {formatCurrency(history.amount)} {suffix}
                  </span>
                ) : (
                  <span className='text-xs font-semibold text-pop-red-500'>
                    -{prefix}
                    {formatCurrency(history.amount)} {suffix}
                  </span>
                )}
                <RewardHistoryStatus
                  status={history?.status}
                  date={formatDateTime(history?.createdAt.toString())}
                />
              </div>
            </section>
            {index !== histories?.length - 1 && <hr />}
          </div>
        ))}
      </Card>
    </div>
  )
}
